export const couponViews = {
  MODAL: 'modal',
  BUTTON: 'button',
  NONE: 'hidden'
};

export default {};
